import React, { Component } from 'react'

export default class SelectClass extends Component {

	exit = (e, school, year) => {
		e.preventDefault();
		e.stopPropagation();
		this.props.onSelect(school, year);
	}

	render() {
		const options = this.props.options;

		return (
			<div className="select-class-back" onClick={this.exit} >
				<div className="container">
					<div className="row py-3">

						{options.map((school) => (
							<div className="col-12 my-2" key={school.id}>
								<div className="card card-colored shadow">
									<div className="card-body text-center">
										<h5 className="card-title">
											{school.name}
										</h5>
									</div>
									<ul id="SelectClass-btns" className="mb-4">

										{[...Array(school.years)].map((el, i) => (
											<li onClick={(e) => this.exit(e, school, i + 1)} className="btn btn-outline-primary" key={i} >{`${i + 1}. letnik`}</li>
										))}

									</ul>
								</div>
							</div>
						))}

					</div>
				</div>
			</div>

		)
	}
}